import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    clientId: null,
    clientName: null,
    clientEmail: null,

};

const clientIdSlice = createSlice({
    name: "clientId",
    initialState,
    reducers: {
        setClientId: (state, action) => {
            state.clientId = action.payload.clientId;
            state.clientName = action.payload.clientName || null;
            state.clientEmail = action.payload.clientEmail || null;
        },
        clearClientId: (state) => {
            state.clientId = null;
            state.clientName = null;
            state.clientEmail = null;
        },
        updateClientInfo: (state, action) => {
            if (action.payload.clientName !== undefined) {
                state.clientName = action.payload.clientName;
            }
            if (action.payload.clientEmail !== undefined) {
                state.clientEmail = action.payload.clientEmail;
            }
        },
    },
});

export const { setClientId, clearClientId, updateClientInfo } = clientIdSlice.actions;

// Selectors
export const selectClientId = (state) => state.clientId.clientId;
export const selectClientName = (state) => state.clientId.clientName;
export const selectClientEmail = (state) => state.clientId.clientEmail;
export const selectClientInfo = (state) => ({
    clientId: state.clientId.clientId,
    clientName: state.clientId.clientName,
    clientEmail: state.clientId.clientEmail,
});

export default clientIdSlice.reducer;
